import React, { useEffect, useState } from "react";
import { callBackendApi } from "../../methods/axiosInstances/backendInstance/apiRequest";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  FormLabel,
  Grid,
  Stack,
  styled,
  TextField,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../store/snackbarSlice/snackbarSlice";
import { useNavigate } from "react-router-dom";

const SuccessCreatedUserFirst = () => {
  const [sessionDetails, setSessionDetails] = useState({});
  const [sessionId, setSessionId] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getSessionDetails = async (sessionId) => {
    try {
      const response = await callBackendApi(
        `stripe-get-session-details/${sessionId}`,
        "GET"
      );
      setSessionDetails(response.data);
    } catch (error) {
      console.error("Error fetching session details:", error);
    }
  };

  useEffect(() => {
    // Extract sessionId from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const extractedSessionId = urlParams.get("session_id");

    if (extractedSessionId) {
      setSessionId(extractedSessionId);
      getSessionDetails(extractedSessionId);
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (sessionDetails.payment_status !== "paid") {
    return (
      <p>
        Something happened with your payment processing. Please contact support
      </p>
    );
  }

  return (
    <SignInContainer>
      <Card>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <h1>Thank you for purchasing with us!</h1>
              <h2>You can start your journey with us!</h2>
              <Button onClick={navigate('/customer/dashboard')}>Go to Dashboard</Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </SignInContainer>
  );
};
export default SuccessCreatedUserFirst;

const SignInContainer = styled(Stack)(({ theme }) => ({
  height: "calc((1 - var(--template-frame-height, 0)) * 100dvh)",
  minHeight: "100%",
  padding: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(4),
  },
  "&::before": {
    content: '""',
    display: "block",
    position: "absolute",
    zIndex: -1,
    inset: 0,
    backgroundImage:
      "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
    backgroundRepeat: "no-repeat",
    ...theme.applyStyles("dark", {
      backgroundImage:
        "radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))",
    }),
  },
}));
